<template>
  <transition name="bounce">
    <div class="l-loading" v-if="visible">
      <img class="loading-img" src="./images/loading.gif" alt="" />
      <!-- <p>{{ msg }}</p> -->
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      msg: ' ',
      visible: false,
    }
  },
}
</script>

<style lang="stylus" scoped>
.bounce-enter-active
  animation bounce-in 0.3s
.bounce-leave-active
  animation bounce-in 0.2s reverse
@keyframes bounce-in
  0%
    opacity 0
  100%
    opacity 1
.l-loading
  width 100%;
  height: 100%;
  position fixed
  z-index 2001
  top 0
  left 0
  background-color rgba(0, 0, 0, 0.7)
  // border-radius 18px
  text-align center
  box-shadow 0 1px 2px 3px rgba(0, 0, 0, 0.7)
  p
    color #fff
    padding 0
    margin 0 0 10px 0
    font-size 14px
  .loading-img
    width 300px
    position absolute
    top 50%
    left 50%
    transform: translate(-50%,-50%);
  
</style>
